import React from 'react'
import { TextField } from '@cicero/ui'
import { IEditorCell, IEditorCellEditableArgs } from './types'

export const DefaultCellRenderer: IEditorCell<string> = {
  id: 'default',
  description: 'Just shows a value as a string and TextField to edit it',
  renderer: ({ value }: { value: string }) => <>{value}</>,
  editableRenderer: ({ value, setValue, onBlur }: IEditorCellEditableArgs<string>) =>
    <TextField
      variant="outlined"
      value={value}
      autoFocus
      onChange={(e) => setValue(e.target.value)}
      onKeyPress={(e) => e.key === 'Enter' ? onBlur() : e.key === 'Esc' ? onBlur() : null}
    />,
}
